import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import Select from '@blocks/Select'
import React from 'react'

export default function PromocodeForm({ model: clubpromo, clubs }: Props) {
    const club = clubs?.find(item => item.value === clubpromo?.club.id.toString())

    return (
        <Grid>
            <Select id="club_id" name="club_id" label="Group" options={clubs} value={club} />
            <Input type="number" id="discount" name="discount" label="Discount" placeholder="30" defaultValue={clubpromo?.discount} />
        </Grid>
    )
}

interface Props extends Modules.Resource.Form<Resources.ClubPromo> {
    clubs?: Interfaces.Options
}